export const BYTES_TO_GB = 1024 * 1024 * 1024;
